var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 11.2C23.4722 11.2 22.1648 10.6521 21.0778 9.5564C19.9907 8.46067 19.4463 7.14187 19.4444 5.6C19.4444 4.06 19.9889 2.74213 21.0778 1.6464C22.1667 0.550667 23.4741 0.00186667 25 0C26.5278 0 27.8361 0.5488 28.925 1.6464C30.0139 2.744 30.5574 4.06187 30.5556 5.6C30.5556 7.14 30.012 8.4588 28.925 9.5564C27.838 10.654 26.5296 11.2019 25 11.2ZM16.6667 56V19.6H0V14H50V19.6H33.3333V56H27.7778V39.2H22.2222V56H16.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/Accessibility.10d88bd6ccda5bf84832579242b88431.svg";
export { ForwardRef as ReactComponent };